import React, { useEffect } from 'react';
import WorkOrderGrid from '../../../features/cfi/work-order-grid/components/WorkOrderGrid';
import { useTitle } from "../../../contexts/title";

export default function WorkOrdersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Work Orders')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<WorkOrderGrid />
			</div>
		</React.Fragment>
	)
} 
